"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var initialState = function () {
    return {
        availableOptions: [],
        selectedOptions: []
    };
};
var state = initialState();
var mutations = {
    SET_AVAILABLE_OPTIONS: function (state, payload) {
        state.availableOptions = payload;
    },
    SET_SELECTED_OPTIONS: function (state, payload) {
        state.selectedOptions = state.selectedOptions.filter(function (o) { return o.product_id !== payload.product_id; });
        state.selectedOptions.push(payload);
    }
};
var actions = {
    getAvailableOptions: function (_a, payload) {
        var state = _a.state, commit = _a.commit;
        commit('SET_AVAILABLE_OPTIONS', payload);
    },
    updateSelectedOption: function (_a, payload) {
        var state = _a.state, commit = _a.commit;
        commit('SET_SELECTED_OPTIONS', payload);
    }
};
var getters = {
    availableOptions: function (state) {
        return state.availableOptions;
    },
    requiredOptions: function (state, getters) {
        return getters.availableOptions.filter(function (o) {
            return o.required === 1;
        });
    },
    totalPrices: function (state) {
        var prices = {
            priceInclTax: 0,
            priceExclTax: 0,
            totalPriceInclTax: 0,
            totalPriceExclTax: 0
        };
        state.selectedOptions.forEach(function (o) {
            prices.priceInclTax += (o.price * o.qty);
            prices.priceExclTax += (o.price * o.qty);
            prices.totalPriceInclTax += (o.price * o.qty);
            prices.totalPriceExclTax += (o.price * o.qty);
        });
        return prices;
    },
    isSaleable: function (state, getters) {
        var selectedRequiredOptions = [];
        getters.requiredOptions.forEach(function (o) {
            selectedRequiredOptions.push(state.selectedOptions.filter(function (r) {
                return r.option_id === o.option_id && r.qty > 0;
            }).length > 0);
        });
        return selectedRequiredOptions.every(Boolean);
    }
};
var CatalogBundleProduct = {
    namespaced: true,
    state: state,
    mutations: mutations,
    actions: actions,
    getters: getters
};
exports.default = CatalogBundleProduct;
